import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { StikeUserService } from 'src/app/modules/case-new-view/stike-user.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-strike-alert-user',
  templateUrl: './strike-alert-user.component.html',
  styleUrls: ['./strike-alert-user.component.scss'],
})
export class StrikeAlertUserComponent implements OnInit {
  constructor(
    //  private readonly dialog: MatDialog,
    private readonly userService: UserService,
    private readonly strikeUserService: StikeUserService,
    private readonly route: ActivatedRoute,
    private readonly unitsService: UnitsService,
    private fb: FormBuilder
  ) {
    this.unitId = route.snapshot.paramMap.get('id');
  }
  filter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  get canCreate() {
    return this.userService.permissions.createRoles;
  }
  get canEdit() {
    return this.userService.permissions.editRoles;
  }

  get canDelete() {
    return this.userService.permissions.deleteRoles;
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<any>;

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
  }

  displayedColumns: string[] = ['spacing', 'gai', 'user', 'createdAt', 'count'];
  userSelected;
  createdAt;
  users: IUser[] = [];
  unitId: string;
  strikesUser: any[] = [];
  caseTypes: any[] = [];
  date = new Date();
  today = { beging: new Date(), end: new Date() };
  yesterday = {
    beging: new Date(new Date().setDate(new Date().getDate() - 1)),
    end: new Date(),
  };
  last7Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 7)),
    end: new Date(),
  };
  last30Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 30)),
    end: new Date(),
  };
  dates = // ['Hoy', 'Ayer', 'Últimos 7 días', 'Últimos 30 días'];
    [
      {
        value: this.today,
        name: 'Hoy',
      },
      {
        value: this.yesterday,
        name: 'Ayer',
      },
      {
        value: this.last7Days,
        name: 'Últimos 7 días',
      },
      {
        value: this.last30Days,
        name: 'Últimos 30 días',
      },
    ];
  setData(strikes: any[]) {
    this.strikesUser = strikes;
    this.dataSource = new MatTableDataSource(strikes);
    this.dataSource.sortingDataAccessor = (data, property) => {
      if (property === 'gai') {
        return data.alert?.gai || '';
      }
    };
    this.dataSource.paginator = this.paginator;

    this.dataSource.sort = this.sort;
  }
  sortData(sort: Sort) {
    console.log('sort', sort);

    this.dataSource.data.sort((a, b) => {
      return compare(a[sort.active], b[sort.active], sort.direction === 'asc');
    });
    this.setData(this.dataSource.data);
  }
  dateRangeForm: FormGroup;

  minDate = new Date();
  endMinDate = new Date();

  ngOnInit() {
    this.dateRangeForm = this.fb.group({
      start: [],
      end: [],
    });
    this.getCaseTypes();
    this.getStikes();
  }

  onStartDateChange() {
    const start = this.dateRangeForm.get('start').value;
    this.endMinDate = start ? start : this.minDate;
    // Si la fecha fin es menor que la nueva fecha inicio, la resetea
    const end = this.dateRangeForm.get('end').value;
    if (end && start && end < start) {
      this.dateRangeForm.get('end').setValue(null);
    }
  }

  getCaseTypes() {
    this.unitsService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes: any) => {
        this.caseTypes = caseTypes;
        this.findUser();
      },
    });
  }

  async findUser() {
    let caseType = this.caseTypes[0];
    const roles = caseType.role;
    const users: IUser[] = [];

    for (const role of roles) {
      const usersByRole = await this.userService
        .getUsersByRole(role)
        .toPromise();
      users.push(...usersByRole);
    }

    this.users = users;
  }
  getStikes() {
    this.strikeUserService
      .getStrikeCountByAlertForUser(this.userSelected, this.createdAt)
      .subscribe((data) => {
        this.setData(data);
      });
  }

  applyDateRange() {
    const range = this.dateRangeForm.value;
    if (range && range.start && range.end) {
      this.createdAt = {
        beging: range.start,
        end: range.end,
      };
      this.getStikes();
    }
  }

  //  createRole() {
  //    this.dialog
  //      .open(CreateRoleComponent, {
  //        width: '700px',
  //        maxHeight: '80vh',
  //        disableClose: true,
  //      })
  //      .afterClosed()
  //      .subscribe({
  //        next: (role) => {
  //          if (role) {
  //            this.rolesList.unshift(role);
  //            this.setData(this.rolesList);
  //            this.dialog.open(SuccessComponent, {
  //              data: {
  //                title: 'Rol creado correctamente',
  //              },
  //            });
  //          }
  //        },
  //      });
  //  }

  //  removeRole(id: string) {
  //    let roles = this.rolesList.filter((role) => role._id !== id);
  //    this.setData(roles);
  //  }

  //  confirmDelete() {
  //    return new Promise((resolve) => {
  //      this.dialog
  //        .open(ConfirmComponent, {
  //          data: {
  //            title: '¿Desea eliminar este Rol? ',
  //          },
  //        })
  //        .afterClosed()
  //        .subscribe({ next: (result) => resolve(result) });
  //    });
  //  }

  //  unisByRole(role: any) {
  //    return role.units.map((unit) => unit.name).join(', ');
  //  }

  //  edit(role: IRole) {
  //    this.dialog
  //      .open(CreateRoleComponent, {
  //        width: '700px',
  //        maxHeight: '80vh',
  //        data: { role },
  //        disableClose: true,
  //      })
  //      .afterClosed()
  //      .subscribe({
  //        next: async (roleUpdated: IRole) => {
  //          await this.userService.getCurrent();
  //          if (roleUpdated) {
  //            const index = this.rolesList.findIndex(
  //              (r) => r._id === roleUpdated._id
  //            );
  //            this.rolesList[index] = roleUpdated;

  //            this.setData(this.rolesList);
  //            this.alert('Rol actualizado correctamente');
  //          }
  //        },
  //      });
  //  }

  //  alert(title: string) {
  //    this.dialog.open(SuccessComponent, {
  //      data: {
  //        title,
  //      },
  //    });
  //  }
  //  suggestion(data) {
  //    this.dialog.open(SuggestionModalComponent, {
  //      data,
  //    });
  //  }

  //  async delete(id) {
  //    let response = await this.confirmDelete();
  //    if (response) {
  //      this.roleService.deleteRole(id).subscribe({
  //        next: (res: any) => {
  //          if (res.notDelete) {
  //            this.suggestion(res);
  //          } else {
  //            this.removeRole(id);

  //            this.alert('Rol eliminado correctamente');
  //          }
  //        },
  //      });
  //    }
  //  }

  //  async changeStatus(id) {
  //    this.roleService.changeStatus(id).subscribe((role) => {
  //      console.log(role);
  //    });
  //  }
}
function compare(
  a: number | string | Date,
  b: number | string | Date,
  isAsc: boolean
): number {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
